import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

// Country / state / city lists come from our own backend (geo_* tables, a scraped copy of countriesnow.space).
// Every list is [{ id, name, ... }].
export const getAllCountries = createAsyncThunk('thirdParty/getAllCountries', async () => {
  try {
    return await apiRequest({ url: 'geo/countries', method: 'get' });
  } catch (e) {
    console.error(e);
    return [];
  }
});
export const getAllStates = createAsyncThunk('thirdParty/getAllStates', async (countryId) => {
  try {
    return await apiRequest({ url: `geo/states?countryId=${countryId}`, method: 'get' });
  } catch (e) {
    console.error(e);
    return [];
  }
});
export const getAllCities = createAsyncThunk('thirdParty/getAllCities', async (stateId) => {
  try {
    return await apiRequest({ url: `geo/cities?stateId=${stateId}`, method: 'get' });
  } catch (e) {
    console.error(e);
    return [];
  }
});

const initialState = {
  allCountries: {
    data: [],
    loading: false,
  },
  allStates: {
    data: [],
    loading: false,
  },
  allCities: {
    data: [],
    loading: false,
  },
};

const thridPartySlice = createSlice({
  name: 'thirdParty',
  initialState,
  reducers: {
    changeStateValue: (state, payload) => {
      const { name, value } = payload;
      state[name] = value;
    },
    clearAllStates: (state) => {
      state.allStates = {
        data: [],
        loading: false,
      };
    },
    clearAllCities: (state) => {
      state.allCities = {
        data: [],
        loading: false,
      };
    },
  },
  extraReducers: (builder) => {
    //-------------- All Countries ----------------

    builder.addCase(getAllCountries.pending, (state) => {
      state.allCountries.loading = true;
    });
    builder.addCase(getAllCountries.fulfilled, (state, action) => {
      state.allCountries.loading = false;

      state.allCountries.data = action.payload?.data ?? [];
    });

    //-------------- All States ----------------

    builder.addCase(getAllStates.pending, (state) => {
      state.allStates.loading = true;
    });
    builder.addCase(getAllStates.fulfilled, (state, action) => {
      state.allStates.loading = false;

      state.allStates.data = action.payload?.data ?? [];
    });

    //-------------- All Cities ----------------

    builder.addCase(getAllCities.pending, (state) => {
      state.allCities.loading = true;
    });
    builder.addCase(getAllCities.fulfilled, (state, action) => {
      state.allCities.data = action.payload?.data ?? [];
      state.allCities.loading = false;
    });
  },
});

export const { changeStateValue, clearAllCities, clearAllStates } = thridPartySlice.actions;
export default thridPartySlice.reducer;
